"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVAILABLE_COUNTRIES = exports.MAX_LENGTH_FOR_COUNTRY = void 0;
var MAX_LENGTH_FOR_COUNTRY = {
  US: 14,
  CA: 14,
  AU: 14
};
exports.MAX_LENGTH_FOR_COUNTRY = MAX_LENGTH_FOR_COUNTRY;
var AVAILABLE_COUNTRIES = [{
  name: '+1 (US)',
  value: 'US'
}, {
  name: '+1 (CA)',
  value: 'CA'
}, {
  name: '+61 (AU)',
  value: 'AU'
}];
exports.AVAILABLE_COUNTRIES = AVAILABLE_COUNTRIES;